import { createAsyncThunk } from "@reduxjs/toolkit";
import UserAPI from "../../api/UserAPI";
import CheckListAPI from "../../api/CheckListAPI";
import AdminAPI from "../../api/AdminAPI";

export const fetchUserInfo = createAsyncThunk(
    "user/fetchUserInfo",
    async (_, { rejectWithValue }) => {
        try {
            const userData = await UserAPI.fetchUserInfo();
            return userData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const fetchAdminInfo = createAsyncThunk(
    "user/fetchAdminInfo",
    async (_, { rejectWithValue }) => {
        try {
            const adminInfo = await AdminAPI.fetchAdminInfo();
            let userData = null;

            try {
                userData = await UserAPI.fetchUserInfo();
            } catch (_) {
                userData = null;
            }

            return {
                commonData: {
                    userId: adminInfo.id,
                    name: adminInfo.name,
                    email: adminInfo.email ?? null,
                    profilePhotoUrl: adminInfo.profilePhotoUrl,
                },
                adminData: {
                    cafes: adminInfo.cafes ?? [],
                },
                userData,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const fetchAdminChecklistId = createAsyncThunk(
    "user/fetchAdminChecklist",
    async () => {
        return await AdminAPI.fetchAdminChecklistID();
    }
);

export const fetchCafes = createAsyncThunk(
    "user/fetchCafes",
    async (_, { rejectWithValue }) => {
        try {
            const response = await AdminAPI.fetchAdminInfo();
            return response.cafes;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createUser = createAsyncThunk(
    "user/createUser",
    async (_, { rejectWithValue }) => {
        try {
            const userData = await UserAPI.createUser();
            return userData;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const updateUserExp = createAsyncThunk(
    "user/updateUserExp",
    async (exp, { rejectWithValue }) => {
        try {
            const userData = await UserAPI.updateExp(exp);
            return userData;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const fetchChecklistID = createAsyncThunk(
    "user/fetchChecklistID",
    async (_, { rejectWithValue }) => {
        try {
            const checklistId = await CheckListAPI.fetchChecklistID();
            return checklistId.id;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
